import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import { CustomerForm } from 'constants/enums/formTypes'
import {
	ApplicationDispatchContext,
	LOAN_APPLICATION_ACTIONS,
} from 'contexts/ApplicationContext'
import { FormFactory } from 'formBuilder/formFactory'
import { formKeySelector, resetFormControlsStateAction } from 'formBuilder/src'
import FormBuilder from 'formBuilder/src/components/FormBuilder'
import { IApplicationContext } from 'interfaces/i-application-context-props'
import { IApplicationInformation } from 'interfaces/i-application-information'
import React, { useContext, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getLanguageLocale, getMarket } from 'utils/countryHelpers'

type FillPersonalDataUKProps = {
	locked: boolean
}

export const FillPersonalDataUK = ({ locked }: FillPersonalDataUKProps) => {
	const { t } = useTranslation()
	const { loanApplication, dispatchLoanApplication }: IApplicationContext =
		useContext(ApplicationDispatchContext)

	let applicationDetailsFormSchema = FormFactory(
		CustomerForm.ApplicationUpdateForm,
		{
			formName: 'applicationUpdateForm',
			blockName: 'applicationUpdateForm',
			market: getMarket(),
			locale: getLanguageLocale(),
			getDataUrl: '',
			validationErrorList: false,
			requiredMessage: t('ValidateRequired'),
		},
		loanApplication.applicationData as IApplicationInformation,
		// sanitizeApplicationData(
		// 	loanApplication.applicationData as IApplicationInformation,
		// ),
	)
	const applicationDetailsFormStateValues = useSelector(
		formKeySelector(
			applicationDetailsFormSchema.formMeta.formName,
			'controlsState',
		),
	)
	const dispatch = useDispatch()
	const wasLockedRef = useRef(locked)

	// discard unsaved edits and restore original values when edit mode is cancelled
	useEffect(() => {
		if (locked && !wasLockedRef.current) {
			dispatch(resetFormControlsStateAction(applicationDetailsFormSchema))
		}
		wasLockedRef.current = locked
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [locked])

	// whenever any field is updated in the forms, dispatch the updateApplicationData on the loanApplication
	useEffect(() => {
		dispatchLoanApplication({
			type: LOAN_APPLICATION_ACTIONS.SET_UPDATE_APPLICATIONDATA,
			payload: {
				...loanApplication,
				updateApplicationData: {
					...loanApplication.updateApplicationData,
					applicant: {
						...loanApplication.updateApplicationData?.applicant,
						personalInfo: {
							...loanApplication.updateApplicationData?.applicant
								?.personalInfo,
							firstName:
								applicationDetailsFormStateValues?.firstName
									.value,
							lastName:
								applicationDetailsFormStateValues?.lastName
									.value,
							gender: applicationDetailsFormStateValues?.gender
								.value,
							title: applicationDetailsFormStateValues?.title
								.value,
							maritalStatus:
								applicationDetailsFormStateValues?.maritalStatus
									.value,
							birthDate:
								applicationDetailsFormStateValues?.birthDate
									.value,
							countryOfBirth:
								applicationDetailsFormStateValues
									?.countryOfBirth.value,
							cityOfBirth:
								applicationDetailsFormStateValues?.cityOfBirth
									.value,
							nationality:
								loanApplication.applicationData?.personalInfo
									?.nationality,
							// citizenship:
							// 	loanApplication.applicationData?.personalInfo
							// 		?.citizenship,
						},

						contacts: {
							...loanApplication.updateApplicationData?.applicant
								?.contacts,
							email: applicationDetailsFormStateValues?.email
								.value,
							// cellPhone:
							// 	loanApplication.applicationData?.contacts
							// 		?.cellPhone,
						},
						employment: {
							...loanApplication.updateApplicationData?.applicant
								?.employment,
							occupationType:
								applicationDetailsFormStateValues
									?.occupationType.value,
							employedSince:
								applicationDetailsFormStateValues?.employedSince
									.value,
							employerName:
								applicationDetailsFormStateValues?.employerName
									.value,
							jobTitle:
								applicationDetailsFormStateValues?.jobTitle
									.value,
							industry:
								applicationDetailsFormStateValues?.industry
									.value,
							monthlyNetIncome:
								applicationDetailsFormStateValues
									?.monthlyNetIncome.value,
							otherIncome:
								applicationDetailsFormStateValues?.otherIncome
									.value,
						},
						address: {
							...loanApplication.updateApplicationData?.applicant
								?.address,
							streetNumber:
								applicationDetailsFormStateValues?.streetNumber
									.value,
							street: applicationDetailsFormStateValues?.street
								.value,
							flatNumber:
								applicationDetailsFormStateValues?.flatNumber
									.value,
							buildingName:
								applicationDetailsFormStateValues?.buildingName
									.value,
							zip: applicationDetailsFormStateValues?.zip.value,
							city: applicationDetailsFormStateValues?.city.value,
							// countryOfResidence:
							// 	loanApplication.applicationData?.address
							// 		.countryOfResidence,
							timeAtAddress:
								applicationDetailsFormStateValues?.timeAtAddress
									.value,
						},
						formerAddress: {
							...loanApplication.updateApplicationData?.applicant
								?.formerAddress,
							streetNumber:
								applicationDetailsFormStateValues
									?.formerStreetNumber.value,
							street: applicationDetailsFormStateValues
								?.formerStreet.value,
							flatNumber:
								applicationDetailsFormStateValues
									?.formerFlatNumber.value,
							buildingName:
								applicationDetailsFormStateValues
									?.formerBuildingName.value,
							zip: applicationDetailsFormStateValues?.formerZip
								.value,
							city: applicationDetailsFormStateValues?.formerCity
								.value,
							// countryOfResidence:
							// 	loanApplication.applicationData?.formerAddress
							// 		?.country,
						},
						accommodation: {
							...loanApplication.updateApplicationData?.applicant
								?.accommodation,
							type: applicationDetailsFormStateValues
								?.accomodationType.value,
							cost: applicationDetailsFormStateValues?.cost.value,
							childrenInFamily:
								applicationDetailsFormStateValues
									?.childrenInFamily.value,
							childcareCost:
								applicationDetailsFormStateValues?.childcareCost
									.value,
						},
					},
				},
			},
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [applicationDetailsFormStateValues])

	return (
		<div className="update-personal-data">
			<div className="update-personal-data-section">
				{applicationDetailsFormSchema ? (
					<FormBuilder
						formSchema={applicationDetailsFormSchema}
						apiError={undefined}
						showErrorsInForm={true}
						showSubmitButton={false}
						fieldLockMode={false}
						formLockMode={true}
						formLocked={locked}
					/>
				) : (
					<CircleSpinner />
				)}
			</div>
		</div>
	)
}
